module.exports = __webpack_public_path__ + "static/media/mail.24a6fe91.svg";